import React from "react";
import SearchItem from "./SearchItem";

export default function SearchSection({selectedIndex, items, title, onHover}) {
    if (!items.length) {
        return null;
    }

    return <div>
        <div className="font-size-0-75 line-height-4 text-uppercase text-gray-medium">{title}</div>
        <div className="font-size-0-875">
            {items.map((item, index) => <SearchItem slug={item.slug} onHover={() => onHover(index)} name={item.name} key={item.id} selected={index === selectedIndex}/>)}
        </div>
    </div>
}